import React from "react";

const LoadableLoading = () => (
  <div className=" flex justify-center items-center h-full">
    <span className="loadable_loader" />
  </div>
);

export default LoadableLoading;
